import styled from "styled-components";

export const TitleContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 24px;

  svg {
    margin-right: 0.5rem;
  }
`;

export const StyledTable = styled.div`
  width: 100%;
  border-top: 1px solid #eaecee;
  border-radius: 8px 8px 0 0;
  overflow: hidden;

  .columnTitle {
    justify-content: flex-end;
    height: 54px;
    font-weight: 600;
    background-color: #eaecee;

    div {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .show {
      justify-content: space-around !important;

      svg {
        width: 18px;
        height: 18px;
      }
    }
  }

  .operationsRow {
    height: 60px;

    div {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: white;
      border-right: 1px solid #eaecee;
      border-bottom: 1px solid #eaecee;
    }
    .rowLabel {
      flex-grow: 1;
      background-color: var(--velotax-ghost) !important;
      justify-content: flex-start;
      padding-left: 1rem;
      background-color: transparent;
      border-left: 1px solid #eaecee;
    }

    &:last-of-type {
      .rowLabel {
        border-bottom-left-radius: 8px;
      }
      div {
        &:last-of-type {
          border-bottom-right-radius: 8px;
        }
      }
    }
  }

  .resumoRow {
    height: 42px;
    .secondary {
      padding-left: 32px;
      font-size: 11px;
    }
  }

  .chevronIcon {
    display: none;
  }

  @media only screen and (max-device-width: 812px) {
    .resumoRow {
      .secondary {
        padding-left: 8px;
        font-size: 11px;
      }
    }
    .operationsRow {
      .rowLabel {
        font-size: 9px;
      }
    }
  }

  @media only screen and (max-device-width: 670px) {
    font-size: 11px;

    .hide {
      display: none !important;
    }
    .show {
      width: 300px;
      max-width: 300px;
      flex: 0 0 300px;
    }
    .transparent {
      opacity: 0;
    }
    .chevronIcon {
      display: block;
    }
  }
  @media only screen and (max-device-width: 550px) {
    .operationsRow {
      .rowLabel {
        width: min-content;
        padding-left: 8px;
      }
    }
    .resumoRow .rowLabel {
      min-width: 160px;
    }
    .resumoRow .secondary {
      min-width: 160px;
      padding-left: 8px;
    }
    .show {
      width: 150px;
      max-width: 150px;
      flex: 0 0 150px;
    }
  }
`;

export const VendasContainer = styled.div`
  background-color: var(--velotax-background-color-ghost);
  padding: 1rem 1rem 1rem 1rem;
  #title {
    font-weight: 600;
    margin-bottom: 4px;
  }
`;

export const LoadingContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  background-color: rgba(255, 255, 255, 0.8);
`;
